import Base from './Base';
import Parse from 'parse';

/**
 * @var firstName
 */
export default class User extends Base {
  constructor(parseObject) {
    super();
    if (!parseObject) parseObject = new Parse.User();
    this.setParseObject(parseObject);

    /**
     * @lends User.prototype
     */
    this._init({
      username: '',
      email: '',
      firstname: '',
      lastname: '',
      language: 'en',
      company: '',
      street: '',
      zipCode: '',
      city: '',
      country: '',
      phone: '',
    });
    this.setAttributes(parseObject.toJSON());
  }

  static collection(parseObjects) {
    return parseObjects.map((el) => new User(el));
  }
}
